<template>
  <Label for="datePicker" @click="open = true">
    <TextInput
      id="datePicker"
      :modelValue="formatDate(modelValue)"
      :label="label"
      :size="size"
      readonly
      :errorMessage="errorMessage"
      @touchstart="open = true"
    >
      <template #button>
        <ResponsivePopover
          v-model:open="open"
          @update:open="(value) => (open = value)"
          :title="$t('components.task_details.log_time.form.date')"
          :align="alignPopover"
        >
          <button
            :disabled="disabled"
            class="py-3 md:py-[9px] px-[11px] -my-[9px] -mx-[11px]"
          >
            <Icon name="calendar-default" size="xl" />
          </button>
          <template #content>
            <DatePicker
              :modelValue="modelValue"
              :minDate="minDate"
              :maxDate="maxDate"
              :isRequired="required"
              @update:modelValue="
                (value) => {
                  $emit('update:modelValue', value);
                  open = false;
                }
              "
            />
          </template>
        </ResponsivePopover>
      </template>
    </TextInput>
  </Label>
</template>

<script setup>
import { ref } from "vue";
import { Label } from "radix-vue";
import { DatePicker } from "@/SharedComponents/Date";
import { TextInput } from "@/SharedComponents/Inputs";
import { ResponsivePopover } from "@/SharedComponents/Popover";
import { Icon } from "@/SharedComponents/Icon";
import { useDate } from "@/Composables/useDate";

defineEmits(["update:modelValue"]);

defineProps({
  modelValue: { type: [Date, String, Number], default: null },
  label: { type: String, required: true },
  size: { type: String, required: false },
  minDate: { type: Date, default: null },
  maxDate: { type: Date, default: null },
  required: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  errorMessage: { type: String, required: false },
  alignPopover: { type: String, required: false },
});

const open = ref(false);

const { formatDate } = useDate();
</script>
